import React, { useEffect, useState } from "react";
import { Card, CardContent } from "../../../components/ui/card";
import { DollarSign } from "lucide-react";
import Spinner from "../../../components/ui/spinner";
import { getRevenue } from "../../../services/apiservices/support";

const MonthlyRevenueCard = ({ timeRange }) => {
  const [revenue, setRevenue] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setRevenue(null);
    setLoading(true);
    getRevenue(timeRange).then((data) => {
      setRevenue(data);
      setLoading(false);
    });
  }, [timeRange]);


  return (
    <Card className="bg-white dark:bg-[#2c3440]">
      <CardContent className="p-24">
        <div className="flex items-center justify-between">
          <div className="flex items-center">
            <div className="p-8 bg-blue-100 dark:bg-blue-900/20 rounded-lg mr-12">
              <DollarSign className="h-6 w-6" />
            </div>
            <div>
              <p className="text-sm font-medium text-gray-600 dark:text-gray-400">
                Monthly Revenue
              </p>
              <p className="text-2xl font-bold">
                {loading ? <Spinner size="sm" /> : `$${Number(revenue).toLocaleString()}`}
              </p>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default MonthlyRevenueCard;
